import { PARTNER_UTM } from '../data/partners'

/** Adds StartupFuel referral UTM parameters to an outbound partner URL. */
export function withPartnerUtm(url: string, partnerSlug: string, placement: string) {
  try {
    const target = new URL(url)
    target.searchParams.set('utm_source', PARTNER_UTM.source)
    target.searchParams.set('utm_medium', PARTNER_UTM.medium)
    target.searchParams.set('utm_campaign', `partner_${partnerSlug}`)
    target.searchParams.set('utm_content', placement)
    return target.toString()
  } catch {
    return url
  }
}
